module.exports = __webpack_public_path__ + "assets/img/ercode-2.923f77fc.jpg";